export default __webpack_public_path__ + "static/media/banner-460x200-bg-blue-template.97795988.svg";